import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { OrderOfOperationsLevelOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * How hard the expressions are. The levels run grade 4 to grade 6: two
 * operations, three operations, parentheses, then a squared or cubed term.
 * See ADR 0019 §4.
 */
export function OrderOfOperationsSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleLevelChange(value: OrderOfOperationsLevelOptions) {
        if (!value) return;
        setSettings({ ...settings, OrderOfOperationsLevel: value });
    }

    return (
        <div className="orderOfOperationsContainer">
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.expressionsLabel')}</span>
            </div>
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.OrderOfOperationsLevel}
                    onChange={(e) => handleLevelChange(e.value)}
                    options={withLabels(Object.values(OrderOfOperationsLevelOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.expressionLevelAria')}
                />
            </div>
        </div>
    );
}

export default OrderOfOperationsSettings;
